module.exports = __webpack_public_path__ + "static/assets/daeb6901354026e23e25b5e3002b1f73.png";